import MaxMinReading from './MaxMinReading';

export default MaxMinReading;
